/** @module Endpoint/list */
/**
 * get all courses
 */
export const GET_ALL_COURSE = '/www/v2/header-navigation/all-courses'
/**
 * get important courses
 */
export const GET_IMPORTANT_COURSE = '/www/v2/header-navigation/important-course-groups'
/**
 * get search
 * @type {string}
 */
export const SEARCH_BOX = '/www/v1/search-box/search'
export const GET_PROVINCES = '/www/v1/search-box/provinces'

// auth
/**
 * fetch list of countries code for register and login
 */
export const GET_COUNTRIES_LIST = '/auth/v1/get-countries'
/**
 * send mobile number for start login or registration
 */
export const REGISTRATION = '/auth/v1/mobile-registration-confirmation'
/**
 * login user by password
 */
export const LOGIN_BY_PASSWORD = '/auth/v1/login-by-password'
/**
 * send otp code for mobile user
 */
export const SEND_CODE = '/auth/v1/mobile-verification-send-code'
/**
 * check otp code
 */
export const CHECK_CODE = '/auth/v1/login-by-mobile-verification'
/**
 * set password when register new user
 */
export const SET_PASSWORD = '/auth/v1/set-password'
/**
 * change password when forget password
 */
export const CHANGE_PASSWORD = '/auth/v1/set-password'
/**
 * set fullname new user
 */
export const SET_FULLNAME = '/auth/v1/register-fullname'
/**
 * get information user
 */
export const GET_USER = '/auth/v1/'
/**
 * logout
 */
export const LOGOUT = '/auth/v1/logout'

/**
 * upload tus file
 * @type {string}
 */
export const UPLOAD_FILE = '/file/v1/upload-tus'
// store global
/**
 * filter teacher list
 */
export const GET_FILTER_TEACHER = '/www/v2/tutor/list/fetch'
/**
 * best teacher list
 */
export const GET_BEST_TEACHER_LIST = '/www/v2/tutor/best-list'
/**
 * get link params
 */
export const GET_LINK_PARAMS = '/www/v2/tutor/list/link-parameters'

/**
 * get search box lists tutoring cities
 */
export const GET_TUTORING_CITIES = '/www/v1/search-box/cities'
/**
 * get search box lists tutoring courses
 */
export const GET_TUTORING_COURSES = '/www/v1/search-box/tutoring-courses'

/**
 * Get IPG Payment Link
 * @param uuid
 * @returns {`/www/v1/invoice/${string}/online-payment`}
 * @constructor
 */
export const GET_PAYMENT_LINK = ({ uuid }) => `/www/v1/invoice/${uuid}/online-payment`
/**
 * get all class private
 * @type {string}
 */
export const GET_ALL_CLASS = '/www/v1/profile/private-classes'
/**
 * Get Private Class Details
 * @param id
 * @returns {`/www/v1/profile/private-classes/${string}`}
 * @constructor
 */
export const GET_CLASS_DETAILS = ({ id }) => `/www/v1/profile/private-classes/${id}`
/**
 * Get Class Discount Packs
 * @param id
 * @returns {`/www/v1/profile/private-classes/${string}/discount-packs`}
 * @constructor
 */
export const GET_CLASS_DISCOUNT_PACK = ({ id }) => `/www/v1/profile/private-classes/${id}/discount-packs`
/**
 *  Get Class Sessions
 * @param id
 * @returns {`/www/v1/profile/private-classes/${string}/sessions`}
 * @constructor
 */
export const GET_CLASS_SESSION = ({ id }) => `/www/v1/profile/private-classes/${id}/sessions`
/**
 * get for testimonials students
 */
export const TESTIMONIALS_LIST_HOME = '/www/v1/home/testimonials'
/**
 * get  teacher request
 */
export const GET_TEACHER_REQUEST = '/www/v1/profile/teacher-requests'
/**
 * Get All User Invoices
 */
export const GET_INVOICE = '/www/v1/profile/invoices'
/**
 *  Get All User Credits
 * @type {string}
 */
export const GET_WALLET_LIST = '/www/v1/profile/wallet'
/**
 * get teachers feedback
 */
/**
 * Get Teacher request info
 * @type {string}
 */
export const TEACHER_REQUEST_COMMENTS = '/www/v2/tutor/profile/feedbacks'

export const GET_TEACHER_FEEDBACK = '/www/v1/tutor-profile/feedbacks-and-story'
/**
 * get top teacher
 */
export const GET_TOP_TEACHERS = '/www/v1/home/top-teachers'
/**
 * Get Teacher Video Package List
 * @type {string}
 */
export const PACKAGE_FETCH = '/www/v1/tutor-packages/fetch'

export const CONFIG = '/www/v1/config/global'

export const TUTORING_PACKAGE_COURSES = '/www/v1/search-box/tutoring-package-courses'
export const GET_DISCOUNT_LIST = ({ id }) => `/www/v1/profile/private-classes/${id}/discount-packs/purchase`
export const GET_DISCOUNT_DEPOSIT = ({ id, packId }) => `/www/v1/profile/private-classes/${id}/discount-packs/deposit/${packId}`
export const GET_LAST_CLASS = '/www/v1/profile/private-classes/latest'
export const GET_LAST_TEACHER_REQUEST = '/www/v1/profile/teacher-requests/latest'
export const GET_SESSION_PACKAGE_PROFILE = ({ id }) => `/www/v1/profile/tutor-packages/session/${id}`
export const GET_TICKET = ({ id }) => `/www/v1/profile/tickets/${id}`
export const STORE_FEEDBACK = ({ id }) => `/www/v1/profile/private-classes/${id}/feedback`
export const TEACHER_DAY = ({ id }) => `/www/v1/profile/private-classes/${id}/teacher-day-message`
export const STORE_DEPOSIT = ({ id, sessions }) => `/www/v1/profile/private-classes/${id}/sessions/${sessions}/deposit`
export const GET_CALLBACK_PAYMENT = ({ uuid }) => `/www/v1/invoice/${uuid}/callback`
